import Vue from 'vue';
import Router from 'vue-router';
import settings from "@/settings";

//views
import AccessDenied from "@/views/errors/AccessDenied";
import Agenda from "@/views/agenda/Agenda";
import AgendaSingle from "@/views/agenda/AgendaSingle";
import AgendaSingleDetails from "@/views/agenda/AgendaSingleDetails";
import AgendaSingleMain from "@/views/agenda/AgendaSingleMain";
import Agreement from "@/views/authentication/Agreement";
import Authenticate from "@/views/authentication/Authenticate";
import Challenge from "@/views/idea/Challenge";
import ChallengesTab from "@/views/ideas/ChallengesTab";
import Clients from "@/views/clients/Clients";
import ClientSingle from "@/views/clients/ClientSingle";
import ContactUs from "@/views/ContactUs";
import CustomCompanyContent from "@/views/CustomCompanyContent";
import EngageForBusiness from "@/views/EngageForBusiness";
import Files from "@/views/Files";
import GlobalDeliveryNetwork from "@/views/GDN/GlobalDeliveryNetwork";
import GlobalDeliveryNetworkSingle from "@/views/GDN/GlobalDeliveryNetworkSingle";
import HireRequest from "@/views/projects/HireRequest";
import Home from "@/views/Home";
import Idea from "@/views/idea/Idea";
import IdeaFormPage from "@/views/idea/IdeaFormPage";
import IdeaOverview from "@/views/idea/IdeaOverview";
import Ideas from "@/views/ideas/Ideas";
import IdeasTab from "@/views/ideas/IdeasTab";
import IdeaStatus from "@/views/idea/IdeaStatus";
import InternalServerError from "@/views/errors/InternalServerError";
import Layout from "@/views/Layout";
import Login from "@/views/authentication/Login";
import MeetYourTeam from "@/views/MeetYourTeam";
import News from "@/views/news/News";
import NewsSingle from "@/views/news/NewsSingle";
import NotFound from "@/views/errors/NotFound";
import Performance from "@/views/Performance";
import PrivacyPolicy from "@/views/PrivacyPolicy";
import Profile from "@/views/profile/Profile";
import ProfileAwards from "@/views/profile/ProfileAwards";
import ProfileForm from "@/views/profile/ProfileForm";
import ProfileIdeas from "@/views/profile/ProfileIdeas";
import Projects from "@/views/projects/Projects";
import ProjectSingle from "@/views/projects/ProjectSingle";
import QuizIndex from "@/views/quiz/QuizIndex";
import QuizLeaderboard from "@/views/quiz/QuizLeaderboard";
import QuizLevelStart from "@/views/quiz/QuizLevelStart";
import QuizQuestion from "@/views/quiz/QuizQuestion";
import QuizLevelEnd from "@/views/quiz/QuizLevelEnd";
import QuizEnd from "@/views/quiz/QuizEnd";
import SelectCompany from "@/views/authentication/SelectCompany";
import Solution from "@/views/solution/Solution";
import SolutionAssets from "@/views/solution/SolutionAssets";
import SolutionContacts from "@/views/solution/SolutionContacts";
import SolutionMain from "@/views/solution/SolutionMain";
import Solutions from "@/views/solution/Solutions";
import WhatWeDoForYou from "@/views/WhatWeDoForYou";
import Tester from "@/views/Tester";
import QuizList from "@/views/quiz/QuizList";
import LeaderboardList from "@/views/quiz/LeaderboardList";
import Quiz from "@/views/quiz/Quiz";
import Bookmarks from "@/views/Bookmarks";

// Components

Vue.use(Router);


const router = new Router({
  routes: [
    //auth
    {
      path: '/authenticate',
      name: 'Authenticate',
      component: Authenticate
    },
    {
      path: '/agreement',
      name: 'Agreement',
      component: Agreement
    },
    {
      path: '/company-select',
      name: 'SelectCompany',
      component: SelectCompany
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    //errors
    {
      path: '/403',
      name: 'AccessDenied',
      component: AccessDenied,
    },
    {
      path: '/404',
      name: 'NotFound',
      component: NotFound,
    },
    {
      path: '/500',
      name: 'InternalServerError',
      component: InternalServerError,
    },
    {
      path: '/tester',
      name: 'Tester',
      component: Tester,
    },
    {
      component: Layout,
      path: '/:companySlug',
      children: [
        //module: AGENDA
        {
          path: 'agenda',
          name: 'Agenda',
          component: Agenda
        },
        {
          path: 'agenda/:id',
          component: AgendaSingle,
          children: [
            {
              path: 'details',
              name: 'AgendaSingleDetails',
              component: AgendaSingleDetails,
            },
            {
              path: '',
              name: 'AgendaSingleMain',
              component: AgendaSingleMain,
            },
          ]
        },
        {
          path: 'bookmarks',
          name: 'Bookmarks',
          component: Bookmarks
        },
        //module: CLIENTS
        {
          path: 'clients',
          name: 'Clients',
          component: Clients
        },
        {
          path: 'clients/:id',
          name: 'ClientSingle',
          component: ClientSingle
        },
        //module: CONTACTUS
        {
          path: 'contact-us',
          name: 'ContactUs',
          component: ContactUs
        },
        //module: SETTINGCOMPANYCONTENT
        // {
        //   path: '/MACSverse/page/:slug',
        //   name: 'MACSverseCustomCompanyContent',
        //   component: CustomCompanyContent
        // },
        {
          path: 'page/:slug',
          name: 'CustomCompanyContent',
          component: CustomCompanyContent
        },
        {
          path: 'page/:slug/solution/:id',
          component: Solution,
          children: [
            {
              path: 'assets',
              name: 'SolutionAssets',
              component: SolutionAssets,
            },
            {
              path: 'contacts',
              name: 'SolutionContacts',
              component: SolutionContacts,
            },
            {
              path: '',
              name: 'SolutionMain',
              component: SolutionMain,
            },
          ]
        },
        //engage-for-business
        {
          path: 'engage-for-business',
          name: 'EngageForBusiness',
          component: EngageForBusiness
        },
        //module: FILES
        {
          path: 'files',
          name: 'Files',
          component: Files
        },
        //module: GDN
        {
          path: 'global-delivery-network',
          name: 'GlobalDeliveryNetwork',
          component: GlobalDeliveryNetwork
        },
        {
          path: 'global-delivery-network/:slug',
          name: 'GlobalDeliveryNetworkSingle',
          component: GlobalDeliveryNetworkSingle
        },
        //module: IDEABOARD
        {
          path: 'challenge/:id',
          component: Challenge,
          name: 'Challenge',
        },
        {
          path: 'idea/new',
          component: IdeaFormPage,
          name: 'AddIdea',
        },
        {
          path: 'idea/:id/edit',
          name: 'EditIdea',
          component: IdeaFormPage,
        },
        {
          path: 'idea/:id',
          component: Idea,
          children: [
            {
              path: 'status',
              name: 'IdeaStatus',
              component: IdeaStatus,
            },
            {
              path: '',
              name: 'IdeaOverview',
              component: IdeaOverview,
            },
          ]
        },
        {
          path: 'ideas',
          component: Ideas,
          children: [
            {
              path: 'challenges',
              name: 'ChallengesTab',
              component: ChallengesTab,
            },
            {
              path: '/',
              name: 'IdeasTab',
              component: IdeasTab,
            }
          ]
        },
        //module: MEETYOURTEAM
        {
          path: 'meet-your-team',
          name: 'MeetYourTeam',
          component: MeetYourTeam
        },
        //module: NEWSFORYOU
        {
          path: 'news',
          name: 'News',
          component: News
        },
        {
          path: 'news/:id',
          name: 'NewsSingle',
          component: NewsSingle
        },
        //PrivacyPolicy
        {
          path: 'performance',
          name: 'Performance',
          component: Performance
        },
        {
          path: 'privacy-policy',
          name: 'PrivacyPolicy',
          component: PrivacyPolicy
        },
        //profile
        {
          path: 'profile',
          component: Profile,
          children: [
            {
              path: 'awards',
              name: 'ProfileAwards',
              component: ProfileAwards,
            },
            {
              path: 'ideas',
              name: 'ProfileIdeas',
              component: ProfileIdeas,
            },
            {
              path: '',
              name: 'ProfileEdit',
              component: ProfileForm,
            },
          ]
        },
        //module: PROJECTANDINITIATIVES
        {
          path: 'hiring-requests/:id',
          name: 'HireRequest',
          component: HireRequest
        },
        {
          path: 'projects',
          name: 'Projects',
          component: Projects
        },
        {
          path: 'projects/:id',
          name: 'ProjectSingle',
          component: ProjectSingle
        },
        //module: QUIZ
        {
          path: 'quizzes',
          name: 'QuizIndex',
          component: QuizIndex,
          children: [
            {
              path: 'leaderboard',
              name: 'LeaderboardList',
              component: LeaderboardList
            },
            {
              path: '',
              name: 'QuizList',
              component: QuizList
            },
          ]
        },
        {
          path: 'quizzes/:id',
          name: 'Quiz',
          component: Quiz,
          children: [
            {
              path: 'question/:idQuestion',
              name: 'QuizQuestion',
              component: QuizQuestion
            },
            {
              path: 'start',
              name: 'QuizLevelStart',
              component: QuizLevelStart
            },{
              path: 'end',
              name: 'QuizEnd',
              component: QuizEnd
            },
            {
              path: 'level/:level',
              name: 'QuizLevelEnd',
              component: QuizLevelEnd
            },
            {
              path: 'next/:level',
              name: 'QuizNextLevelStart',
              component: QuizLevelStart
            },
          ]
        },
        {
          path: 'quizzes/leaderboard/:id',
          name: 'QuizLeaderboard',
          component: QuizLeaderboard
        },
        //module: SOLUTIONSFORYOU
        {
          path: 'solutions/:slug',
          name: 'Solutions',
          component: Solutions
        },
        {
          path: 'solutions/:slug/:id',
          component: Solution,
          children: [
            {
              path: 'assets',
              name: 'SolutionProcessAssets',
              component: SolutionAssets,
            },
            {
              path: 'contacts',
              name: 'SolutionProcessContacts',
              component: SolutionContacts,
            },
            {
              path: '',
              name: 'SolutionProcess',
              component: SolutionMain,
            },
          ]
        },
        {
          path: '/solutions/s/:id',
          component: Solution,
          children: [
            {
              path: 'assets',
              name: 'SolutionProcessAssetsSingle',
              component: SolutionAssets,
            },
            {
              path: 'contacts',
              name: 'SolutionProcessContactsSingle',
              component: SolutionContacts,
            },
            {
              path: '',
              name: 'SolutionProcessSingle',
              component: SolutionMain,
            },
          ]
        },
        //module: WHATWEDOFORYOU
        {
          path: 'what-we-do-for-you',
          name: 'WhatWeDoForYou',
          component: WhatWeDoForYou
        },
        // {
        //   path: 'MACSverse',
        //   name: 'MACSverse',
        //   component: Home,
        // },
        {
          path: '',
          name: 'Home',
          component: Home,
        },
      ]
    },
  ],

  mode: 'history',
  base: settings.BASE_PATH,

  // Prevents window from scrolling back to top
  // when navigating between components/views
  //third postion savedPositions
  scrollBehavior(to, from) {
    if (to.matched.length > 2 && to.matched[1] === from.matched[1]) {
      return false;
    }
    if (to.name === from.name) {
      return false;
    }
    return { x: 0, y: 0 };
  },
});



export default router;
